import React, { useState } from 'react';
import ReactTable from 'react-table'
import numeral from "numeral";
import {isAuthenticated} from "../../store/action/auth";

const ProductTable = props => {
    const { user } = isAuthenticated();

    const columns = [{
        Header: '#',
        Cell: ({row,original}) => row._index+1,
        maxWidth: 75,
        className:'text-center',
        headerClassName: 'text-center'
    },{
        Header: 'GAMBAR',
        maxWidth: 100,
        accessor: 'image',
        Cell: ({row,original}) => productCell(original)
    },{
        Header: 'NAMA PRODUK',
        accessor: 'name',
        Cell: ({row,original}) => nameCell(original)
    },{
        Header: 'SKU',
        accessor: 'sku'
    },{
        Header: 'KATEGORI',
        accessor: 'category', // String-based value accessors!
    },{
        Header: 'STOK DIJUAL',
        accessor: 'stock', // String-based value accessors!
    },{
        Header: 'STOK GUDANG',
        accessor: 'quantity', // String-based value accessors!
        Cell: ({row,original}) => warehouseCell(row,original)
    },{
        Header: 'HARGA',
        accessor: 'price',
        Cell: ({row,original}) => priceCell(original)
    },{
        Header: 'AKTIF',
        accessor: 'status',
        maxWidth: 85,
        Cell: ({row, original}) => statusCell(original)
    },{
        Header: 'EDIT',
        maxWidth: 100,
        accessor: 'edit',
        className:'text-center',
        headerClassName: 'text-center',
        Cell: ({row,original}) => editCell(original)
    }];

    const nameCell = (og) => {
        return (
            <div>
                <b>{og.name}</b><br/>
                {og.details}
            </div>
        )
    };

    const statusCell = (og) => {
        return (
            <div style={{paddingTop:'6px'}}>
                <div className="custom-control custom-switch">
                    <input
                        onChange={() =>  onEditProduct(og, 'status')}
                        type="checkbox"
                        className="custom-control-input "
                        checked={og.status === 'active'}
                        id={og.id}/>
                    <label className="custom-control-label" htmlFor={og.id}></label>
                </div>
                {
                    user.role === 'admin' && og.status === 'deleted' ?
                    <span className="badge badge-danger border border-danger">deleted</span>
                        : null
                }
            </div>
        )
    };

    const priceCell = (og) => {
        return (
            <div>
                Rp. {numeral(og.price).format("0,0")}
            </div>
        )
    };

    const productCell = (og) => {
        if (!og.image) {
            return (
                <i>no image</i>
            )
        }
        return (
            <div>
                <img src={og.image} style={{height:50, width:50}} className="rounded"/>
            </div>
        )
    };

    const warehouseCell = (row,og) => {
        let stockButtons = (
            <div>
                <div className="col-2">
                    <span
                        className="badge badge-primary border border-primary pointer"
                        onClick={() => {props.onAddStock(row._index,og.sku)}}
                    >
                        Tambah
                    </span>
                </div>
                <div className="col-2">
                    <span
                        className="badge badge-primary border border-primary pointer"
                        onClick={() => props.onRemoveStock(row._index,og.sku)}
                    >
                        Kurang
                    </span>
                </div>
                <div className="col-2">
                    <span
                        className="badge badge-warning border border-warning pointer"
                        onClick={() => props.onRestoreStock(row._index,og.sku)}
                    >
                        Restore
                    </span>
                </div>
            </div>
        );

        if (og.quantity > 0) {
            return (
                <div>
                    {og.quantity} { og.quantity !== og.stockUpdate && user.role === 'admin'? `(${og.stockUpdate})` : null }
                    { user.role === 'admin' ? stockButtons : null}
                </div>
            )
        }
        return (
            <div>
                <i>tidak ada</i> { og.quantity !== og.stockUpdate && user.role === 'admin'? `(${og.stockUpdate})` : null }
                { user.role === 'admin' ? stockButtons : null}
            </div>
        )
    };

    const editCell = (og) => {
        return (
            <div className="actions ml-3 row">
                <a onClick={() => onEditProduct(og, 'edit')}
                   className="action-item mr-2"
                   data-toggle="tooltip"
                   title="Edit"
                >
                    <i className="fas fa-edit"></i>
                </a>
                <a onClick={() => onRemoveProduct(og)}
                   className="action-item mr-2"
                   data-toggle="tooltip"
                   title="Trash"
                >
                    <i className="fas fa-trash"></i>
                </a>
            </div>
        )
    };

    const onEditProduct = (og, type) => {
        if (type === 'status') {
            if (og.status === "notActive") {
                og['status'] = 'active'
            } else {
                og['status'] = 'notActive'
            }
        }
        let data = {
            categories: props.categories,
            productId: og.id,
            productName: og.name,
            productSku: og.sku,
            productDetails: og.details,
            productCategory: og.category,
            productImage: og.image,
            productLength: og.length,
            productWidth: og.width,
            productHeight: og.height,
            productWeight: og.weight,
            productPrice: og.price,
            productStock: og.stock,
            productStatus: og.status
        };
        if (type === 'status') {
            props.onClickProductStatus(data)
        } else {
            props.onClickEditProduct(data);
        }
    };

    const onRemoveProduct = (og) => {
        props.onClickRemoveProduct(og.id);
    };

    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={10}
                filterable
                loading={props.loading}
                className="-striped -highlight"
            />
        </div>
    )
};

export default ProductTable;
